export default "Primes CEE secteur AGRI, PCAE régional (FEADER) et FranceAgriMer pour vos serres, hangars, étables et bâtiments d'exploitation. Diagnostic gratuit en 60 sec, aucune avance de trésorerie.";
